// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__G6hb0","center":"Page_center__1dwJ9","overflow":"Page_overflow__30EmX"};